import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { SUBSCRIPTION_LICENSE_TYPE, SUBSCRIPTION_STATUS } from '@constants/tenantConstants';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import create from 'zustand';
import axios from 'axios';
export var useTenantStore = create(//@ts-ignore
devtools(subscribeWithSelector(function(set, get) {
    var safeSet = function safeSet(key) {
        return function(value) {
            return set(function(state) {
                return state[key] === value ? state : _define_property({}, key, value);
            });
        };
    };
    var createInitialState = function createInitialState() {
        return {
            tenant: null,
            tenantId: '',
            tenantSettings: null,
            goalTypes: [],
            isBetaTenant: false,
            //! TODO Remove this after bulk calibration is fully rolled out to all tenants.
            isBulkCalibrationEnabledTenant: false,
            taskSubscription: null
        };
    };
    var setTenantData = function setTenantData(param) {
        var tenant = param.tenant, tenantId = param.tenantId, settings = param.settings, isBetaTenant = param.isBetaTenant, //! TODO Remove this after bulk calibration is fully rolled out to all tenants.
        isBulkCalibrationEnabledTenant = param.isBulkCalibrationEnabledTenant;
        set(function() {
            var _ref, _ref1, _ref2;
            return _object_spread_props(_object_spread({}, createInitialState()), {
                tenant: tenant,
                tenantId: tenantId,
                tenantSettings: (_ref = settings !== null && settings !== void 0 ? settings : tenant === null || tenant === void 0 ? void 0 : tenant.settings) !== null && _ref !== void 0 ? _ref : null,
                isBetaTenant: (_ref1 = isBetaTenant !== null && isBetaTenant !== void 0 ? isBetaTenant : tenant === null || tenant === void 0 ? void 0 : tenant.isBetaTenant) !== null && _ref1 !== void 0 ? _ref1 : false,
                //! TODO Remove this after bulk calibration is fully rolled out to all tenants.
                isBulkCalibrationEnabledTenant: (_ref2 = isBulkCalibrationEnabledTenant !== null && isBulkCalibrationEnabledTenant !== void 0 ? isBulkCalibrationEnabledTenant : tenant === null || tenant === void 0 ? void 0 : tenant.isBulkCalibrationEnabledTenant) !== null && _ref2 !== void 0 ? _ref2 : false
            });
        });
    };
    var setTaskSubscription = safeSet('taskSubscription');
    var setGoalTypes = safeSet('goalTypes');
    var getSetGoalTypes = function getSetGoalTypes() {
        return _async_to_generator(function() {
            var goalTypes, fetchGoalTypes, fetchedGoalTypes, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        goalTypes = get().goalTypes;
                        if (!(goalTypes.length === 0)) return [
                            3,
                            5
                        ];
                        fetchGoalTypes = function fetchGoalTypes() {
                            return _async_to_generator(function() {
                                var response, goalTypes, response1, goalTypesWithSubTypes;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                axios.get('/api/goal/getAllGoalTypes')
                                            ];
                                        case 1:
                                            response = _state.sent();
                                            goalTypes = response.data;
                                            if (!((goalTypes === null || goalTypes === void 0 ? void 0 : goalTypes.length) > 0)) return [
                                                3,
                                                3
                                            ];
                                            return [
                                                4,
                                                axios.post('/api/goal/getBulkSubGoalTypes', {
                                                    goalTypes: goalTypes
                                                })
                                            ];
                                        case 2:
                                            response1 = _state.sent();
                                            goalTypesWithSubTypes = response1.data;
                                            return [
                                                2,
                                                goalTypesWithSubTypes
                                            ];
                                        case 3:
                                            return [
                                                2,
                                                goalTypes
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchGoalTypes()
                        ];
                    case 2:
                        fetchedGoalTypes = _state.sent();
                        if (fetchedGoalTypes.length > 0) {
                            safeSet('goalTypes')(fetchedGoalTypes);
                        }
                        return [
                            2,
                            fetchedGoalTypes
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            2,
                            goalTypes
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        return [
                            2,
                            goalTypes
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var reloadGoalTypes = function reloadGoalTypes() {
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                safeSet('goalTypes')([]);
                return [
                    2,
                    getSetGoalTypes()
                ];
            });
        })();
    };
    var isProfessionalTrial = function isProfessionalTrial() {
        var _tenant_trialSubscription, _tenant_trialSubscription1;
        var tenant = get().tenant;
        if (!tenant) {
            return false;
        }
        return ((_tenant_trialSubscription = tenant.trialSubscription) === null || _tenant_trialSubscription === void 0 ? void 0 : _tenant_trialSubscription.isExpired) === false && ((_tenant_trialSubscription1 = tenant.trialSubscription) === null || _tenant_trialSubscription1 === void 0 ? void 0 : _tenant_trialSubscription1.licenseType) === SUBSCRIPTION_LICENSE_TYPE.PROFESSIONAL;
    };
    var isFreeOnProfessionalTrial = function isFreeOnProfessionalTrial() {
        var _get_tenant;
        return isProfessionalTrial() && ((_get_tenant = get().tenant) === null || _get_tenant === void 0 ? void 0 : _get_tenant.subscriptionStatus) === SUBSCRIPTION_STATUS.FREE;
    };
    var isProfessionalSubscription = function isProfessionalSubscription() {
        var tenant = get().tenant;
        if (!tenant) {
            return false;
        }
        if (isProfessionalTrial()) {
            return true;
        }
        return tenant.subscriptionStatus === SUBSCRIPTION_STATUS.ACTIVE && tenant.subscriptionLicenseType === SUBSCRIPTION_LICENSE_TYPE.PROFESSIONAL;
    };
    var hasModuleExtraBenefit = function hasModuleExtraBenefit(moduleKey) {
        var _tenant_trialSubscription, _tenant_trialSubscription_extraBenefits_activatedFeatures, _tenant_trialSubscription_extraBenefits, _tenant_trialSubscription1, _tenant_settings_extraBenefits_activatedFeatures, _tenant_settings_extraBenefits, _tenant_settings;
        var tenant = get().tenant;
        if (!tenant) {
            return false;
        }
        var hasTrialBenefit = ((_tenant_trialSubscription = tenant.trialSubscription) === null || _tenant_trialSubscription === void 0 ? void 0 : _tenant_trialSubscription.isExpired) === false && ((_tenant_trialSubscription1 = tenant.trialSubscription) === null || _tenant_trialSubscription1 === void 0 ? void 0 : (_tenant_trialSubscription_extraBenefits = _tenant_trialSubscription1.extraBenefits) === null || _tenant_trialSubscription_extraBenefits === void 0 ? void 0 : (_tenant_trialSubscription_extraBenefits_activatedFeatures = _tenant_trialSubscription_extraBenefits.activatedFeatures) === null || _tenant_trialSubscription_extraBenefits_activatedFeatures === void 0 ? void 0 : _tenant_trialSubscription_extraBenefits_activatedFeatures.includes(moduleKey));
        var hasPermanentBenefit = (_tenant_settings = tenant.settings) === null || _tenant_settings === void 0 ? void 0 : (_tenant_settings_extraBenefits = _tenant_settings.extraBenefits) === null || _tenant_settings_extraBenefits === void 0 ? void 0 : (_tenant_settings_extraBenefits_activatedFeatures = _tenant_settings_extraBenefits.activatedFeatures) === null || _tenant_settings_extraBenefits_activatedFeatures === void 0 ? void 0 : _tenant_settings_extraBenefits_activatedFeatures.includes(moduleKey);
        return Boolean(hasTrialBenefit || hasPermanentBenefit);
    };
    var hasAccessToProfessionalModule = function hasAccessToProfessionalModule(moduleKey) {
        return isProfessionalSubscription() || hasModuleExtraBenefit(moduleKey);
    };
    var isAiSettingEnabled = function isAiSettingEnabled(settingName) {
        var isNegative = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var tenantSettings = get().tenantSettings;
        if (!tenantSettings || tenantSettings.aiDisabled) {
            return false;
        }
        var settingValue = tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings[settingName];
        return isNegative ? !settingValue : settingValue;
    };
    var isAgentSettingEnabled = function isAgentSettingEnabled(settingName) {
        var isNegative = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var tenantSettings = get().tenantSettings;
        if (!tenantSettings) {
            return false;
        }
        var settingValue = tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings[settingName];
        return isNegative ? !settingValue : settingValue;
    };
    return _object_spread_props(_object_spread({}, createInitialState()), {
        setTenantData: setTenantData,
        setTaskSubscription: setTaskSubscription,
        setGoalTypes: setGoalTypes,
        getSetGoalTypes: getSetGoalTypes,
        reloadGoalTypes: reloadGoalTypes,
        isProfessionalTrial: isProfessionalTrial,
        isFreeOnProfessionalTrial: isFreeOnProfessionalTrial,
        isProfessionalSubscription: isProfessionalSubscription,
        hasAccessToProfessionalModule: hasAccessToProfessionalModule,
        hasModuleExtraBenefit: hasModuleExtraBenefit,
        isAiSettingEnabled: isAiSettingEnabled,
        isAgentSettingEnabled: isAgentSettingEnabled
    });
}), {
    name: 'TenantStore',
    enabled: process.env.NODE_ENV === 'development'
}));
export var initTenantFromUser = function initTenantFromUser(user) {
    var _user_taskSubscription;
    var tenantStore = useTenantStore.getState();
    if (user.tenant) {
        tenantStore.setTenantData({
            tenant: user.tenant,
            tenantId: user.tenantId,
            settings: user.tenant.settings,
            isBetaTenant: user.isBetaTenant,
            //! TODO Remove this after bulk calibration is fully rolled out to all tenants.
            isBulkCalibrationEnabledTenant: user.isBulkCalibrationEnabledTenant
        });
    }
    tenantStore.setGoalTypes([]);
    tenantStore.setTaskSubscription((_user_taskSubscription = user.taskSubscription) !== null && _user_taskSubscription !== void 0 ? _user_taskSubscription : null);
};
